import React from 'react'
import MaterialSymbol from '../material-symbol'

const Clear = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="clear" {...props} />
))

Clear.displayName = 'Clear'

export default Clear
